import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import {
  Box,
  Grid,
  IconButton,
  Stack,
  Typography,
  styled,
} from '@mui/material';

import { IcDeleteTrash, IcPencil, IcShieldPerson } from '@/assets/images';
import { MasterNameType } from '@/models';
import { colors } from '@/theme/variables';

const ReporterItemRoot = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  padding: '8px 15px',
  borderRadius: 6,
  border: `1px solid ${
    theme.palette.mode === 'light' ? colors.grey[20] : theme.palette.divider
  }`,

  '& .secondaryInfo': {
    color: theme.palette.text.secondary,
  },
  '& .secondaryIcon': {
    color: theme.palette.text.secondary,
  },
}));

interface ReporterItemProps {
  name: string;
  secondaryInfo?: string;
  type: MasterNameType;
  isEmployee?: boolean;
  onEdit?: () => void;
  onRemove?: () => void;
}

export const ReporterItem = ({
  name,
  secondaryInfo,
  type,
  isEmployee,
  onEdit,
  onRemove,
}: ReporterItemProps) => {
  const isOfficer = type === MasterNameType.PERSON && isEmployee;
  const SecondaryIcon =
    type === MasterNameType.PERSON ? PersonOutlineIcon : BusinessOutlinedIcon;

  return (
    <ReporterItemRoot xs={12}>
      <Stack flex={1} spacing={0.35}>
        <Box>
          <Typography
            fontWeight={600}
            sx={{ fontSize: 15, lineHeight: 1.2, color: 'text.primary' }}
          >
            {name}
          </Typography>
        </Box>
        <Stack direction="row" alignItems="center" spacing={0.75}>
          {isOfficer ? (
            <IcShieldPerson
              style={{ width: 16, height: 16, color: colors.grey[80] }}
            />
          ) : (
            <SecondaryIcon
              sx={{ width: 16, height: 16, color: colors.grey[80] }}
            />
          )}
          {secondaryInfo ? (
            <Typography
              className="secondaryInfo"
              sx={{ fontSize: 13, lineHeight: 1.15 }}
            >
              {secondaryInfo}
            </Typography>
          ) : null}
        </Stack>
      </Stack>
      <Stack direction="row">
        {!!onEdit && (
          <IconButton onClick={onEdit}>
            <IcPencil />
          </IconButton>
        )}
        {!!onRemove && (
          <IconButton color="error" onClick={onRemove}>
            <IcDeleteTrash style={{ color: colors.error.main }} />
          </IconButton>
        )}
      </Stack>
    </ReporterItemRoot>
  );
};
